import {
  useLocation,
} from "react-router-dom";


import AppRoutes
  from "./routes/AppRoutes";

import WebsiteRoutes
  from "./routes/WebsiteRoutes";

import PublicOfferRoutes
  from "./routes/PublicOfferRoutes";


import {
  useAuth,
} from "./modules/auth/hooks/useAuth";


/*
|--------------------------------------------------------------------------
| WEBSITE ROUTE CHECK
|--------------------------------------------------------------------------
|
| Public website routes:
|
| /
| /about
| /contact
| /products
| /products/:slug
|
| IMPORTANT:
|
| "/" is special.
|
| When logged out:
|   "/" → Website HomePage
|
| When logged in:
|   "/" → AppRoutes
|
|--------------------------------------------------------------------------
*/

const isWebsiteRoute = (
  pathname,
  isAuthenticated
) => {

  /*
  |--------------------------------------------------------------------------
  | HOME PAGE
  |--------------------------------------------------------------------------
  */

  if (pathname === "/") {
    return !isAuthenticated;
  }


  /*
  |--------------------------------------------------------------------------
  | ABOUT
  |--------------------------------------------------------------------------
  */

  if (pathname === "/about") {
    return true;
  }


  /*
  |--------------------------------------------------------------------------
  | CONTACT
  |--------------------------------------------------------------------------
  */

  if (pathname === "/contact") {
    return true;
  }


  /*
  |--------------------------------------------------------------------------
  | PRODUCTS
  |--------------------------------------------------------------------------
  */

  if (pathname === "/products") {
    return true;
  }


  /*
  |--------------------------------------------------------------------------
  | PRODUCT OVERVIEW
  |--------------------------------------------------------------------------
  */

  if (pathname.startsWith("/products/")) {
    return true;
  }


  return false;
};


/*
|--------------------------------------------------------------------------
| PUBLIC OFFER ROUTE CHECK
|--------------------------------------------------------------------------
|
| Public offer routes:
|
| /offer/:token
| /offer/:token/payment
| /offer/:token/success
|
| These routes:
|
| - do NOT require login
| - do NOT use ProtectedRoute
| - do NOT use RoleRoute
| - do NOT use admin authentication
|
| The token is validated by the backend.
|
|--------------------------------------------------------------------------
*/

const isPublicOfferRoute = (
  pathname
) => {

  if (
    pathname === "/offer"
  ) {
    return true;
  }


  if (
    pathname.startsWith("/offer/")
  ) {
    return true;
  }


  return false;
};


/*
|--------------------------------------------------------------------------
| APP
|--------------------------------------------------------------------------
*/

const App = () => {

  const location =
    useLocation();


  /*
  |--------------------------------------------------------------------------
  | AUTHENTICATION
  |--------------------------------------------------------------------------
  */

  const {
    isAuthenticated,
  } = useAuth();


  /*
  |--------------------------------------------------------------------------
  | CURRENT PATH
  |--------------------------------------------------------------------------
  */

  const pathname =
    location.pathname;


  /*
  |--------------------------------------------------------------------------
  | PUBLIC OFFER
  |--------------------------------------------------------------------------
  |
  | IMPORTANT:
  |
  | Check this BEFORE website/application routes.
  |
  */

  const publicOfferRoute =
    isPublicOfferRoute(
      pathname
    );


  /*
  |--------------------------------------------------------------------------
  | WEBSITE
  |--------------------------------------------------------------------------
  */

  const websiteRoute =
    !publicOfferRoute &&
    isWebsiteRoute(
      pathname,
      isAuthenticated
    );


  /*
  |--------------------------------------------------------------------------
  | RENDER
  |--------------------------------------------------------------------------
  */

  if (publicOfferRoute) {
    return (
      <PublicOfferRoutes />
    );
  }


  if (websiteRoute) {
    return (
      <WebsiteRoutes />
    );
  }


  return (
    <AppRoutes />
  );

};


export default App;
